<template>
    <b-form-group class="w-100 m-0"
        :description="Description">
        <b-input-group>
            <b-form-input
                :id="InputId"
                :disabled="Disabled"
                :readonly="ReadOnly"
                :required="Required"
                :state="state"
                :value="getDateValue(DateValue)"
                type="text"
                autocomplete="on"
                :placeholder="Locale.slice(0, 2) == 'fr' ? 'jj/mm/aaaa' : 'dd/mm/yyyy'"
                @update="updateDateValue($event)"
                @blur="updateTwoDigitYearDate($event)"
                 />
                 <!-- v-mask="navLanguage.slice(0, 2) == 'fr' ? '##/##/####' : '####-##-##'" -->
            <b-input-group-append>
                <b-form-datepicker
                    v-bind="datePickerLabels[Locale.slice(0, 2)] || {}"
                    :disabled="Disabled"
                    :readonly="ReadOnly"
                    :required="Required"
                    :state="state"
                    :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                    :min="MinDate"
                    :max="MaxDate"
                    :size="Size"
                    :locale="Locale" start-weekday="1"
                    v-model="dateValue"
                    placeholder=""
                    button-only
                    right
                    :hide-header="true" :selected-variant="Variant"
                    @shown="dateValue = DateValue"
                    @input="updateDateValue($event)"/>
            </b-input-group-append>
        </b-input-group>
    </b-form-group>
</template>

<script lang="ts">
import {Component, Model, Prop, PropSync, Vue } from 'vue-property-decorator';
import moment from 'moment';
import Dictionary from '@/types/Dictionary';

/** Composant de saisie de date manuelle ou via un bouton afficahnt un calendrier */
@Component
export default class DatePicker extends Vue {
    /** Localisation de la date (fr par défaut) */
    @Prop({ default: () => 'fr'})
    public Locale!: string;

    /** Liste des labels affiché dans le calendrier du form-datepicker */
    private datePickerLabels : Dictionary<any> = {
        fr: {
            labelPrevYear: this.$t('PreviousYear').toString(),
            labelPrevMonth: this.$t('PreviousMonth').toString(),
            labelCurrentMonth: this.$t('CurrentMonth').toString(),
            labelNextMonth: this.$t('NextMonth').toString(),
            labelNextYear: this.$t('NextYear').toString(),
            labelHelp: ''
        }
    };

    /** Variant de couleur */
    @Prop()
    public Variant!: string;

    /** Identifiant de l'input */
    @Prop()
    public InputId!: string;

    /** Indique si la saisie est désactivé ou non */
    @Prop({default: () => false})
    public Disabled!: boolean;

    /** Indique si la saisie est en lecture seule ou non */
    @Prop({default: () => false})
    public ReadOnly!: boolean;

    /** Indique si la saisie est en requise ou non */
    @Prop({default: () => false})
    public Required!: boolean;

    /** Indique l'état de la saisie */
    @PropSync('State')
    private state!: boolean;

    /** Valeur de date minimale */
    @Prop()
    public MinDate!: Date;

    /** Valeur de date maximale */
    @Prop()
    public MaxDate!: Date;

    /** Valeur de taille du composant (sm par défaut) */
    @Prop({ default: () => 'sm'})
    public Size!: string;

    /** Description affichée sous le champ de saisie */
    @Prop({default: () => ""})
    public Description!: string;
    
    @Model('UpdatedDateEvent', { default: () => null })
    public DateValue;//: Date;
    private dateValue : Date = new Date();

    /** Retourne si la date saisie est valide ou non */
    private checkdate(value) {
		console.debug("DatePicker - checkDate -  value : ", value);
		if (value) {
			let fieldDate = moment(value, ['L', 'DD/MM/YYYY', 'DD/MM/YYYY 00:00', 'YYYY-MM-DD 00:00', 'YYYY-MM-DDT00:00:00', 'YYYY-MM-DDT00:00:00'], true);
			return (fieldDate.isValid());
		}
		else
            return false;
	}

    /** Formalise l'affichage de la date saisie */
	private getDateValue(value) {
        console.debug("DatePicker - getDateValue - moment - value : %O - $options.filters.formatDate... : %O", value, this.$options.filters.formatDate(value,  'L'));

		if (this.checkdate(value))
			return this.$options.filters.formatDate(value, 'L');
		else
			return value;
	}

    /** Permet de mettre à jour la date saisie dans l'input */
    private updateDateValue(e) {
        let valueDate = moment(e,  ['L', 'DD/MM/YYYY', 'YYYY-MM-DD'], true).locale(this.Locale);

        let value : string;

        // On suppose que le format attendu est français ou anglais
		if(!e) {
            console.debug("updateDateValue - e : %O", e);
			value = e;
			this.state = null;
		}
        else if (valueDate.isValid()) {
			console.debug('updateDateValue - e : %s - new Date : %s', e, valueDate.format("YYYY-MM-DDTHH:mm:ss"));
			value = valueDate.format("YYYY-MM-DDTHH:mm:ss");
			this.state = null;
		}
		else {
			// Si le champ n'est pas valide alors il sera bloqué lors du Save
			value = e;
			this.state = false;
			console.error("La date '%s' ne respecte pas le format attendu pour le field %O !", e, value);
		}

        this.$emit('UpdatedDateEvent', value);
    }

    /** Permet de modifier lors de la perte de focus la saisie de la date si écrite avec les années sur 2 chiffres */
    private updateTwoDigitYearDate(e){
        let valueDate =  moment(e.target.value, 'L');   // this.Locale.slice(0, 2) == 'fr' ? ["D/M/YY", "DD/MM/YYYY"] : ["YY-M-D", "YYYY-MM-DD"]
        console.debug('updateTwoDigitYearDate - e : %O - new Date : %s', valueDate, valueDate.format("YYYY-MM-DDTHH:mm:ss"));
        
        let value : string;

        if (valueDate.isValid()) {
			value = valueDate.format("YYYY-MM-DDTHH:mm:ss");
			this.state = null;
		}
        else{
            value = e.target.value;
            this.state = false;
        }

        this.dateValue = new Date(value);
        this.$emit('UpdatedDateEvent', value);
    }
}
</script>

<style scoped>
</style>